import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import SmartRetailLinksManager from '@/components/v2/SmartRetailLinksManager.vue';
import SearchMixinProp from '@/helpers/vue_mixins/v2/SearchMixinProp';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import ReferralLinkMixin from '@/helpers/vue_mixins/v2/ReferralLinkMixin';
import BaseText from '@/components/BaseText.vue';
import ActionButton from '@/components/action_button/Index.vue';
import BaseSearchInput from '@/components/v2/BaseSearchInput';
import AppBasicDetails from '@/components/v2/AppBasicDetails';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import CopyToClipboardMixin from '@/helpers/vue_mixins/v2/CopyToClipboardMixin';
import RouterParamsAppMixin from '../../helpers/vue_mixins/RouterParamsAppMixin';
let SmartRetailLinks = class SmartRetailLinks extends Mixins(Mixins(SearchMixinProp, ViewportSizeMixin, ReferralLinkMixin, AlertMixin, CopyToClipboardMixin), RouterParamsAppMixin) {
    get headers() {
        return [
            {
                text: 'LINK ID',
                value: 'linkId',
                align: 'left',
                sortable: false,
            },
            {
                text: 'SMART RETAIL LINK NAME',
                value: 'referralName',
                align: 'left',
                sortable: false,
            },
            {
                text: 'SALES CHANNEL',
                value: 'salesChannel',
                align: 'left',
                sortable: false,
            },
            {
                text: 'CUSTOM URL',
                value: 'referralLink',
                align: 'left',
                sortable: false,
            },
            {
                text: 'DATE & TIME CREATED',
                value: 'dateCreated',
                align: 'left',
                sortable: false,
            },
            {
                text: 'CLICKS',
                value: 'clicks',
                align: 'left',
                sortable: false,
            },
            {
                text: 'ORDERS',
                value: 'referredCount',
                align: 'left',
                sortable: false,
            },
            {
                text: '',
                value: '',
                align: '',
                sortable: false,
            },
        ];
    }
    goToDetails(uuid) {
        this.$router.push({ name: 'ecommerce-referral-details', params: { referralLinkUuid: uuid } });
    }
};
SmartRetailLinks = __decorate([
    Component({
        components: {
            SmartRetailLinksManager,
            BaseText,
            ActionButton,
            BaseSearchInput,
            AppBasicDetails,
        },
    })
], SmartRetailLinks);
export default SmartRetailLinks;
